// ชื่อโดเมนสภาพแวดล้อมการพัฒนา
//https://php-b2csaas.yixiangonline.com
const host_development = 'https://app.litesites.co'

export default {
    // เวอร์ชัน
    version: '3.0.0',
    baseURL: process.env.NODE_ENV == 'production' ? '' : host_development,
    tencentMapKey: 'FWEBZ-WHSHV-IRFPO-UNMRL-5EUWV-BFBFW'
}
